export default __webpack_public_path__ + "static/media/NoResultIcon.025e3286.svg";